import { __extends } from "tslib";
import { Injectable } from '@angular/core';
import { IonicNativePlugin, cordova } from '@ionic-native/core';
var OpenNativeSettings = /** @class */function (_super) {
  __extends(OpenNativeSettings, _super);
  function OpenNativeSettings() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  OpenNativeSettings.prototype.open = function (setting) {
    return cordova(this, "open", {}, arguments);
  };
  OpenNativeSettings.pluginName = "OpenNativeSettings";
  OpenNativeSettings.plugin = "cordova-open-native-settings";
  OpenNativeSettings.pluginRef = "cordova.plugins.settings";
  OpenNativeSettings.repo = "https://github.com/guyromb/Cordova-open-native-settings";
  OpenNativeSettings.platforms = ["Android", "iOS"];
  OpenNativeSettings.decorators = [{
    type: Injectable
  }];
  return OpenNativeSettings;
}(IonicNativePlugin);
export { OpenNativeSettings };
